import React, { Suspense, lazy } from 'react';
import { Redirect, Route, withRouter, Switch } from 'react-router-dom';
import { Loader, ErrorBoundary } from 'components';
import { Endpoints } from 'app-constants';
import { useSelector } from 'react-redux';
import { EditGallery } from 'containers';

const AddImageForm = lazy(() => import('./containers/AddImageForm/AddImageForm'));
const Gallery = lazy(() => import('./containers/ImageGallery/ImageGallery'));
const Login = lazy(() => import('./containers/Login/Login'));

function ProtectedRoute({ component: Component, ...rest }) {
  const isAdmin = useSelector((state) => state.loginReducer.isAdmin);

  return (
    <Route
      {...rest}
      render={(props) => (isAdmin ? (
          <ErrorBoundary>
            <Component {...props} />
          </ErrorBoundary>
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: {
                from: props.location
              }
            }}
          />
        ))
      }
    />
  );
}

const Routes = () => {
  const { ADD_PAGE, EDIT_PAGE } = Endpoints;
  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route exact path={'/'} component={Gallery} />
        <Route exact path={'/login'} component={Login} />
        <ProtectedRoute exact path={ADD_PAGE} component={AddImageForm} />
        <ProtectedRoute exact path={EDIT_PAGE} component={EditGallery} />
      </Switch>
    </Suspense>
  );
};
export default withRouter(Routes);
